import { useT } from "@transifex/react";
import type { ReactNode } from "react";
import { EmptyActivitiesContainer } from "./EmptyActivitiesContainer";

interface ActivitiesSectionProps {
    children?: ReactNode;
}

export const ActivitiesSection = (props: ActivitiesSectionProps) => {
    const t = useT();
    const t_activities = t("Activities", { _tags: "ClassMemberDashboard, ActivitiesSection" });

    return (
        <section className="flex flex-col gap-s w-full">
            <h2 className="text-xl text-p6-grey-dark font-normal">{t_activities}</h2>
            {props.children ?? <EmptyActivitiesContainer />}
        </section>
    );
};
